module.exports = __webpack_public_path__ + "media/dangerous_goods_notification.4e572e43.mp3";